import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import { EmploiDuTemps } from '@teetsh/app/src/types/edt';
import { edtUpdateSerializer } from './serializer';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export default function useUpdateEDT() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { notifyError } = useNotification();
  const user = useUser();
  const { t } = useTranslation(['emploiDuTemps']);
  const queryClient = useQueryClient();
  const requestURL = `/schoolyears/${schoolyear.id}/schools/${school.id}/emplois-du-temps`;
  const { mutateAsync } = useMutation({
    mutationFn: ({ edt }: { edt: EmploiDuTemps }) =>
      request(`${requestURL}/${edt.id}`, {
        method: 'PATCH',
        body: edtUpdateSerializer(edt, user.location),
      }),
    onMutate: ({ edt }) => {
      queryClient.setQueryData<EmploiDuTemps>(
        [schoolyear.id, school.id, EDT_KEY, edt.id],
        edt,
      );

      queryClient.setQueryData<EmploiDuTemps[]>(
        [schoolyear.id, school.id, EDT_KEY, 'list'],
        oldData => {
          if (!oldData) return oldData;
          return oldData.map(item => (item.id === edt.id ? edt : item));
        },
      );
    },
    onError: () => {
      notifyError({
        title: t('emploiDuTemps:messages.edt.updateError'),
      });
    },
  });
  return mutateAsync;
}
